module.exports = __webpack_public_path__ + "static/icon-phone.76b7f3f1.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-phone.png
// module id = 1018
// module chunks = 2